import { FC, memo } from 'react'

import { Link } from '~/components/Link'

import { MathVaultLink } from '~/types/math-vault'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ChevronRightIcon from '~/components/Icons/svgs/ChevronRightIcon'

interface SubMenuItemProps {
  activeClassName: string
  onMouseEnter: (subTopic: MathVaultLink) => void
  item: MathVaultLink
}

const SubMenuItemComponent: FC<SubMenuItemProps> = ({ activeClassName, onMouseEnter, item }) => {
  const justText = Array.isArray(item.children)

  if (justText) {
    return (
      <p
        className={`p-3 space-x-4 flex items-center justify-between rounded text-gray-link cursor-pointer ${activeClassName}`}
        key={item.path}
        onMouseEnter={() => onMouseEnter(item)}
      >
        <span className="text-xs">{item.h1}</span>
        <span className="block shrink-0 text-2.5">
          {'children' in item && <SVGIcon icon={ChevronRightIcon} pathClassName="text-black" size={8} />}
        </span>
      </p>
    )
  }

  return (
    <Link
      className={`p-3 space-x-4 flex items-center justify-between rounded text-gray-link ${activeClassName}`}
      key={item.path}
      onMouseEnter={() => onMouseEnter(item)}
      to={item.path}
    >
      <span className="text-xs">{item.h1}</span>
      <span className="block shrink-0 text-2.5">
        {'children' in item && <SVGIcon icon={ChevronRightIcon} pathClassName="text-black" size={8} />}
      </span>
    </Link>
  )
}
export const SubMenuItem = memo(SubMenuItemComponent)
